import FabPositioned from "../FabPositioned/FabPositioned";
import {
    RefreshContentFab,
    RefreshContentTypography,
} from "./RefreshContentButton.styles";
import { ArrowRotateRightIcon } from "@icons/ArrowRotateRightIcon";
import React, { RefObject } from "react";
import { isPlatformTippspiel } from "@infrastructure/Services/EnvService";

export function RefreshContentButtonBasic({
    onClick,
    scrollToRef,
    isInsideModal = false,
}: {
    isInsideModal: boolean;
    onClick: () => void;
    scrollToRef?: RefObject<HTMLDivElement>;
}) {
    return (
        <FabPositioned
            hideOnEndOfView={false}
            position="center-top"
            isInsideModal={isInsideModal}
            color={"primary"}
        >
            <RefreshContentFab
                onClick={() => {
                    if (scrollToRef) {
                        scrollToRef?.current?.scrollIntoView({
                            block: "start",
                            behavior: "smooth",
                            inline: "nearest",
                        });
                    }
                    onClick();
                }}
                disableRipple={true}
                disableFocusRipple={true}
                disableTouchRipple={true}
                withOrangeColorStyles={isPlatformTippspiel}
            >
                <ArrowRotateRightIcon
                    color={
                        isPlatformTippspiel
                            ? "var(--community-color-snow-white)"
                            : "var(--community-color-primary-text)"
                    }
                    width={"20px"}
                    height={"20px"}
                />
                <RefreshContentTypography>
                    aktualisieren
                </RefreshContentTypography>
            </RefreshContentFab>
        </FabPositioned>
    );
}
